<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <b-row>
      <b-col sm="6">
        <admin-breadcrumb :items="[{ text: 'Shipping', path: {name: 'admin-shipping'} }]" name="Shippers"/>
      </b-col>
      <b-col sm="6" class="text-right align-self-end">
        <no-permission-wrapper :show="!canCreateShippers">
          <b-btn variant="success" @click.prevent="openNewShipperModal" class="mb-4" :disabled="!canCreateShippers">Add New Shipper</b-btn>
        </no-permission-wrapper>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Shippers" sub-title="Manage all shippers created in GreenLists">
          <admin-shippers-table :shippers="shippers"/>
          <template v-slot:header-right>
            <b-form-select
                class="w-auto ml-2"
                v-model="sorting"
                :options="sortingOptions"
                @change="() => loadShippers()"
            />
            <b-form-select
                class="w-auto ml-2"
                v-model="filters.status"
                :options="statusOptions"
                @change="() => loadShippers()"
            />
          </template>
        </admin-panel>
      </b-col>
    </b-row>
    <admin-new-shipper-modal ref="newShipperModal" @created="newShipperCreated"/>
  </b-container>
</template>

<script>
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminPreloader from "../components/AdminPreloader";
import AdminPanel from "../components/AdminPanel";
import {API_ROUTES} from "../api";
import AdminNewShipperModal from "../components/AdminNewShipperModal";
import AdminShippersTable from "../components/AdminShippersTable";
import NoPermissionWrapper from "../components/NoPermissionWrapper.vue";
export default {
  name: "AdminShippers",
  components: {
    NoPermissionWrapper,
    AdminShippersTable, AdminNewShipperModal, AdminPanel, AdminPreloader, AdminBreadcrumb},
  data() {
    return {
      loading: true,
      shippers: [],
      sorting: "",
      sortingOptions: [
        {
          text: "Default Sorting",
          value: ""
        },
        {
          text: "Name A to Z",
          value: "name_asc"
        },
        {
          text: "Name Z to A",
          value: "name_desc"
        },
        {
          text: "First Added",
          value: "first_added"
        },
        {
          text: "Last Added",
          value: "last_added"
        },
      ],
      filters: {
        status: ""
      },
      statusOptions: [
        {
          text: "All Statuses",
          value: ""
        },
        {
          text: "Active",
          value: "1"
        },
        {
          text: "Inactive",
          value: "0"
        },
      ]
    }
  },
  created() {
    this.loadShippers();
  },
  computed: {
    canCreateShippers() {
      return this.$store.getters['auth/hasAdminPermissions']('shipper_create');
    },
    search() {
      return this.$store.state.current.search;
    },
  },
  watch: {
    search() {
      this.loadShippers();
    },
  },
  methods: {
    loadShippers() {
      this.loading = true;
      let params = {};
      if (this.filters.status !== '') {
        params['is_active'] = this.filters.status;
      }
      if (this.search) {
        params['search'] = this.search;
      }
      if (this.sorting) {
        params['sorting'] = this.sorting;
      }
      this.$api.get(API_ROUTES.ADMIN_SHIPPERS, {
        params: params
      }).then(({data}) => {
        this.shippers = data.shippers
      }).catch(({response: {data}}) => {

      }).finally(() => {
        this.loading = false;
      })
    },
    openNewShipperModal() {
      if (!this.canCreateShippers) {
        return this.$bvToast.toast('Sorry! You don\'t have permission to do this action', {
          title: 'Denied!',
          variant: 'danger'
        });
      }
      this.$refs.newShipperModal.open();
    },
    newShipperCreated(shipper) {
      this.shippers.push(shipper);
      this.$refs.newShipperModal.close();
    }
  }
}
</script>
